import { Dispatch, Action } from 'redux';
import { Actions } from './actions';
import { notification } from 'antd';
import { getAccessControl } from './AccessControl';

const createRestrictionMiddleware = () => () => {
    return (next: Dispatch<Actions>) => (action: Action) => {
        if (!getAccessControl().isAllowed(action.type)) {
            notification.error({
                message: 'Access Denied',
                description: 'You do not have access to perform this action',
                duration: 5,
            });
            return;
        }

        const result = next(action);

        return result;
    };
};

const restrictionMiddleware = createRestrictionMiddleware();

export default restrictionMiddleware;
